import { setDeptIndent } from '../feature/text-flex-render'
import { useAutoWidgetPlugins as _useAutoWidgetPlugins } from '../../../../plugins/widget'
import { getMeasureTextWidthCanvas, removeMeasurementSpanCanvas, byteLength } from '../../../kye-table2/utils/dom'
export const WIDGET_PREFIEX = '_current_widget_'

function createPaintSourceText (vm, key, plus) {
  const renderData = vm.$refs.table.store.states.renderData
  const obj = renderData.reduce((obj, cur, i) => {
    const currentWidgetValue = cur[`${WIDGET_PREFIEX}${key}`]
    const sourceWidgetValue = cur[key]
    const l = byteLength(sourceWidgetValue)
    if (plus) {
      if (i === 0) {
        obj.leng = l
        obj.maxPaintText = currentWidgetValue
        obj.maxSourceText = sourceWidgetValue
      } else {
        if (obj.leng > l && sourceWidgetValue) {
          obj.leng = l
          obj.maxPaintText = currentWidgetValue
          obj.maxSourceText = sourceWidgetValue
        }
      }
    } else {
      if (obj.leng < l) {
        obj.leng = l
        obj.maxPaintText = currentWidgetValue
        obj.maxSourceText = sourceWidgetValue
      }
    }
    return obj
  }, {
    leng: 0,
    maxPaintText: null,
    maxSourceText: null
  })
  return obj
}

export function useAutoWidgetPlugins (vm) {
  try {
    const params = {
      getMeasureTextWidth: getMeasureTextWidthCanvas,
      createTextMap: createPaintSourceText,
      reloadData: vm.$refs.table.store.updateTableData.bind(vm.$refs.table.store),
      setCurrentDeptLevel: setDeptIndent,
    }
    const autoWidgetInstance = _useAutoWidgetPlugins(vm, params)
    const handleAutoWidgetEmitEvent = (width, oldWidth, column) => {
      if (autoWidgetInstance) {
        autoWidgetInstance.setDraggingWidgetColumn({...column, width: oldWidth})
        autoWidgetInstance.calculateWidgetTextRange({...column, width})
      }
    }
    vm.$refs.table.$on('header-dragend', handleAutoWidgetEmitEvent)
    const destroy = () => {
      autoWidgetInstance.clearAutoWidgetDraggingCols()
      vm.$refs.table.$off('header-dragend', handleAutoWidgetEmitEvent)
      removeMeasurementSpanCanvas()
    }
    return {
      ...autoWidgetInstance,
      destroy,
      name: 'autoWidgetPlugin'
    }
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/plugins/auto-widget.js